import React from 'react';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import { dataroomUrl } from '@dataroom/url';
import drsUrl from '@drs/url';
import evercallUrl from '@evercall/url';
import cfrUrl from '@/creditflowresearch/infrastructure/url';
import dealroadshowConfig from '@drs/config';
import dataroomConfig from '@dataroom/config';
import BookDemoButton from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModalLegacy/BookDemoButton';
import { LogoDealroadshowStandart } from '@dealroadshow/uikit-logo/Dealroadshow/Standart';

import styles from './footer.module.scss';
import footerLinkStyles from '@framework/ui/Organisms/StickyFooter/FooterLink/footerLink.module.scss';

export const footerConfig = () => ({
  navigation: [
    {
      path: finsightWebUrl.getComplianceUrl(),
      title: 'Compliance',
      shouldOpenInNewTab: true,
    },
    {
      path: finsightWebUrl.getPrivacyPolicyUrl(),
      title: 'Privacy',
      shouldOpenInNewTab: true,
    },
    {
      path: finsightWebUrl.getSecurityPolicyUrl(),
      title: 'Security',
      shouldOpenInNewTab: true,
    },
    {
      path: finsightWebUrl.getTermsOfUseUrl(),
      title: 'Terms',
      shouldOpenInNewTab: true,
    },
  ],
  content: [
    {
      key: 'company',
      title: 'Company',
      collection: [
        {
          title: 'About',
          path: finsightWebUrl.getAboutUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Careers',
          path: finsightWebUrl.getCareersUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Contact',
          path: finsightWebUrl.getContactUsUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Solutions',
          path: finsightWebUrl.getOurProductsUrl(),
          shouldOpenInNewTab: true,
        },
      ],
    },
    {
      key: 'dealroadshow',
      title: 'Deal Roadshow',
      collection: [
        {
          itemCallback: () => (
            <BookDemoButton
              tenant={ dealroadshowConfig.code }
              logoComponent={ LogoDealroadshowStandart }
              className={ footerLinkStyles.link }
              buttonComponent="a"
            />
          ),
        },
        { title: 'Institutional Roadshows', path: '/' },
        { title: 'Retail Roadshows', path: '/retail-roadshows' },
      ],
    },
    {
      key: 'products',
      title: 'Products',
      collection: [
        {
          title: 'Deal Roadshow',
          path: drsUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'DealVDR',
          path: dataroomUrl(dataroomConfig.dealvdr.code).getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Evercall',
          path: evercallUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'CreditFlow',
          path: cfrUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'InvestorSet',
          path: dataroomUrl(dataroomConfig.investorset.code).getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'VeriSend',
          path: dataroomUrl(dataroomConfig.verisend.code).getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: '17g5.com',
          path: dataroomUrl(dataroomConfig['17g5'].code).getUrl(),
          shouldOpenInNewTab: true,
        },
      ],
    },
    {
      key: 'resources',
      title: 'Resources',
      collection: [
        {
          title: 'Log In',
          path: drsUrl.getLoginUrl(),
        },
        {
          title: 'Register',
          path: drsUrl.getRegisterUrl(),
        },
      ],
    },
    {
      key: 'sales',
      title: 'Sales & Support',
      collection: [
        { title: 'Americas', phoneNumber: '+1 888 997 6610 ' },
        { title: 'APAC', phoneNumber: '+852 3018 1600' },
        { title: 'EMEA', phoneNumber: '+44 80 8178 7364' },
        {
          title: dealroadshowConfig.supportEmail,
          path: `mailto:${ dealroadshowConfig.supportEmail }?subject=Deal Roadshow Sales %26 Support Request`,
          linkClassName: styles.mailLink,
        },
      ],
    },
  ],
});
